import React from "react";

export const IconLabValueCursor: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="4" height="24" fill="none">
    <rect
      width="3"
      height="23"
      x=".5"
      y=".5"
      fill="#212121"
      stroke="#fff"
      rx="1.5"
    />
  </svg>
);
